import React, { useState, useEffect } from "react";
import AssignedTo from "./AssignedTo";
import axios from "axios";

const AssignedToMain = ({ onFieldChange, require, Message,   setFormData, setEditModalOpen }) => {
  const [isAssignedToVisible, setIsAssignedToVisible] = useState(false);
  const [adminEmails, setAdminEmails] = useState([]);
  const [selectedEmail, setSelectedEmail] = useState("");

  const apiUrls = process.env.REACT_APP_API_URLS;

  // console.log(apiUrls)
  useEffect(() => {
    const fetchAdminEmails = async () => {
      try {
        const response = await axios.get(`${apiUrls}/superAdmin/admin-emails/`);
        setAdminEmails(response.data);
      } catch (error) {
        console.error("Error fetching emails:", error);
      }
    };

    fetchAdminEmails();
  }, []);

  // console.log(adminEmails)
  const handleOpenAssignedTo = () => {
    setIsAssignedToVisible(require ? false : true);
  };

  const handleCloseAssignedTo = () => {
    setIsAssignedToVisible(false);
  };

  // const handleEmailSelect = (email) => {
  //   setSelectedEmail(email);
  //   onFieldChange("assigned_to", email); // Pass data up to BuyerManagementDetails
  // };

  return (
    <div>
      <div className="flex items-center justify-between">
      <label htmlFor="assignedTo" className="block">
        Assigned to<span className="text-red-500">*</span>
      </label>
       {Message === "dont show icons" ? (
                <></>
              ) : (
              <div className="flex items-center gap-5">
                <span onClick={() => {setFormData({label:"Assigned to",placeholder:"Select"});;setEditModalOpen(true)}} className="text-gray-400 cursor-pointer">✎</span>
                <span className="text-gray-400 cursor-pointer scale-150">x</span>
              </div>)}
      </div>
      <div
        className="border border-gray-400 cursor-pointer rounded-md p-2 mt-1"
        onClick={handleOpenAssignedTo}
      >
        <p>{selectedEmail || "Select"}</p>
      </div>

      {isAssignedToVisible && (
        <AssignedTo
          onClose={handleCloseAssignedTo}
          adminEmails={adminEmails}
          // onEmailSelect={handleEmailSelect}
          onFieldChange={onFieldChange}
        />
      )}
    </div>
  );
};

export default AssignedToMain;
